import httpClientCitasApiKey from '../../services/httpClientCitasApiKey'

export const GetCitCitas = () => {
    return new Promise((resolve, reject) => {
       
        httpClientCitasApiKey.get(`/api/v5/cit_citas`)
        .then(response => {
            resolve(response)
        })
        .catch(error => {
            console.error("Error al obtener citas: ", error);
            reject(error.response || { status: 500, data: { message: 'Error de conexión' } })
        })
    
    })
}

export const GetCitMisCitas = (idUsuarioCitas) => {
    return new Promise((resolve, reject) => {
       
        httpClientCitasApiKey.get(`/api/v5/cit_citas/mis_citas?cit_cliente_id=${idUsuarioCitas}`)
        .then(response => {
            resolve(response)
        })
        .catch(error => {
            console.error("Error al obtener mis citas: ", error);
            reject(error);
        })
    
    })
}

export const DeleteCitas = (citaId) => {
    return new Promise((resolve, reject) => {
        httpClientCitasApiKey.patch('/api/v5/cit_citas/cancelar?cit_cita_id=' + citaId)
        .then(response => {
            resolve(response)
        })
        .catch(error => {
            console.error("Error al cancelar cita: ", error);
            reject(error);
        })
    
    });
}

export const GetDistritos = () => {
    return new Promise((resolve, reject) => {
        
        httpClientCitasApiKey.get('/api/v5/distritos')
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener distritos: ", error);
            reject(error);
            
        })
        
    })
}


export const GetOficinas = (distrito_clave) => {
    return new Promise((resolve, reject) => {
        
        const ruta = `/api/v5/oficinas?distrito_clave=${distrito_clave}`
        httpClientCitasApiKey.get(ruta)
        .then( response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener oficinas: ", error);
            reject(error);
        });
    });
}


export const GetOficinaServicio = (oficina_clave) => {
    return new Promise((resolve, reject) => {
        
        const ruta = `/api/v5/cit_oficinas_servicios?oficina_clave=${oficina_clave}`
        httpClientCitasApiKey.get(ruta)
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener servicios de oficina: ", error);
            reject(error);
        })
        
    })
}


export const GetCitDiasDisponibles = () => {
    return new Promise((resolve, reject) => {
        
        httpClientCitasApiKey.get('/api/v5/cit_dias_disponibles')
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener días disponibles: ", error);
            reject(error)
        })
    
    })
}

export const GetHorasDisponibles = (filtros) => {
    return new Promise((resolve, reject) => {
       
        const ruta = `/api/v5/cit_horas_disponibles?oficina_clave=${filtros.oficina_clave}&cit_servicio_clave=${filtros.cit_servicio_clave}&fecha=${filtros.fecha}`
        
        httpClientCitasApiKey.get(ruta)
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener horas disponibles: ", error);
            reject(error)
        })
    })
}


export const NewCita = (params) => {
    return new Promise((resolve, reject) => {
       
        const ruta = '/api/v5/cit_citas/crear'
        httpClientCitasApiKey.post(ruta, params )
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al crear cita: ", error);
            reject(error)
        })
        
    })
}

export const GetJuzgadosOrigen = () => {
    return new Promise((resolve, reject) => {
        
        httpClientCitasApiKey.get('/api/v5/exp_juzgados')
        .then(response => {
            resolve(response)
        })
        .catch((error) => {
            console.error("Error al obtener juzgados de origen: ", error);
            reject(error)
        })
    
    })
}